var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"box"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.objDetail)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }